import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {TogetherPost, TogetherPostCreateRequest} from './together.model';
import {fileNameFromContentDisposition, saveBlob} from '../../shared/attachment-download';

export const TOGETHER_PDF_MAX_BYTES = 10 * 1024 * 1024;
export const TOGETHER_IMAGE_MAX_BYTES = 5 * 1024 * 1024;

const BASE = `${environment.apiConfig.uri}api/together/posts`;

@Injectable({providedIn: 'root'})
export class TogetherService {
  private readonly http = inject(HttpClient);

  loadPosts(): Observable<TogetherPost[]> {
    return this.http.get<TogetherPost[]>(BASE);
  }

  createPost(data: TogetherPostCreateRequest, file: File | null, image: File | null): Observable<TogetherPost> {
    const formData = new FormData();
    const postBlob = new Blob([JSON.stringify(data)], {type: 'application/json'});
    formData.append('post', postBlob);
    if (file) {
      formData.append('file', file);
    }
    if (image) {
      formData.append('image', image);
    }
    return this.http.post<TogetherPost>(BASE, formData);
  }

  updatePost(id: string, data: TogetherPostCreateRequest, file: File | null, image: File | null): Observable<TogetherPost> {
    const formData = new FormData();
    const postBlob = new Blob([JSON.stringify(data)], {type: 'application/json'});
    formData.append('post', postBlob);
    if (file) {
      formData.append('file', file);
    }
    if (image) {
      formData.append('image', image);
    }
    return this.http.put<TogetherPost>(`${BASE}/${id}`, formData);
  }

  deletePost(id: string): Observable<void> {
    return this.http.delete<void>(`${BASE}/${id}`);
  }

  downloadPdf(id: string): Observable<void> {
    return this.http.get(`${BASE}/${id}/file`, {observe: 'response', responseType: 'blob'}).pipe(
      tap((resp: HttpResponse<Blob>) => {
        const name = fileNameFromContentDisposition(resp.headers.get('Content-Disposition')) ?? 'anhang.pdf';
        if (resp.body) saveBlob(resp.body, name);
      }),
      map(() => undefined),
    );
  }

  loadImageBlob(id: string): Observable<Blob> {
    return this.http.get(`${BASE}/${id}/image`, {responseType: 'blob'});
  }
}
